module.exports = __webpack_public_path__ + "fonts/open-sans/open-sans-bold.woff";